<template>
  <div id="app">
    <toast-messages :extend="extendToast" />
    <top-nav />
    <template v-if="hasCheckedUser">
      <q-r-scanner />
      <popup-activity-form />
      <idle-logout-prompt />
    </template>
    <div class="page-body">
      <router-view v-if="hasCheckedUser" />
      <div v-else class="container">
        <loading-spinner />
      </div>
    </div>
    <page-footer />
    <form-sequence-modal />
    <service-worker-reload :use-register-s-w-function="useRegisterSW" />
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import { Hub } from "aws-amplify/utils";
import { useRegisterSW } from "virtual:pwa-register/vue";
import {
  LoadingSpinner,
  useAuthStore,
  PageFooter,
  ServiceWorkerReload,
  getAppUrl,
  ToastMessages,
  IdleLogoutPrompt,
  usePolling,
} from "@switchsystems/coactive-vue-lib";
import { useHead } from "@unhead/vue";
import TopNav from "@/components/TopNav.vue";
import PopupActivityForm from "@/components/activity/PopupActivityForm.vue";
import QRScanner from "@/components/qr/QRScanner.vue";
import FormSequenceModal from "@/components/form/FormSequenceModal.vue";
import extendToast from "@/lib/extendToast";

export default {
  name: "App",

  components: {
    TopNav,
    LoadingSpinner,
    ToastMessages,
    PopupActivityForm,
    PageFooter,
    QRScanner,
    FormSequenceModal,
    ServiceWorkerReload,
    IdleLogoutPrompt,
  },
  setup() {
    const authStore = useAuthStore();
    const route = useRoute();
    usePolling();

    const routeTitle = computed(() => route.meta.title ?? "");
    useHead({
      title: routeTitle,
      titleTemplate: "%s | Rota | CoActive Care",
    });

    const { hasCheckedUser } = storeToRefs(authStore);

    Hub.listen("authCustom", ({ payload }) => {
      switch (payload.event) {
        case "doLogout":
          window.location.href = `${getAppUrl("home")}/logout`;
          break;
        default:
      }
    });

    return {
      onMounted,
      onUnmounted,
      hasCheckedUser,
      useRegisterSW,
      extendToast,
    };
  },
};
</script>
